<template>
  <div class="content" v-html="content"></div>
</template>

<script>
import { getActivityRuleContent } from "@/api/join";
export default {
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    this._getActivityRuleContent();
    
  },
  methods:{
    _getActivityRuleContent(){
      getActivityRuleContent({ type:this.GetQueryString('type') }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.content = res.content.content;
        }
      })
    }
  },
    beforeRouteEnter(to, from, next) {
        const type = to.query.type;
        let title;
        switch (type) {
            case "54":
                title = "喜悦充值协议";
            break;
        }
        to.meta.title = title;
        document.title = title;
        next();
    },  
};
</script>

<style lang="scss" scoped>
    .content{
        padding: 0 10px;
    }
</style>